import React from 'react';
import PropTypes from 'prop-types';

const Hidden = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...other}>
      <rect id="bound" width="24" height="24" fill="none" />
      <path id="Combined-Shape" d="M19.208,9.848A18.655,18.655,0,0,1,21,12s-4.091,6-9,6q-.466,0-.9-.039Z" fill={color} />
      <path id="Combined-Shape-2" d="M14.505,6.495,12,9a3,3,0,0,0-3,3L5.527,15.473A10.92,10.92,0,0,1,3,12s2.455-6,9-6A6.95,6.95,0,0,1,14.505,6.495Z" fill={color} />
      <rect id="Rectangle" width="19" height="2" transform="translate(5.1 18.435) rotate(-45)" fill={color} opacity="0.3" />
    </svg>
  );
}

Hidden.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

Hidden.defaultProps = {
  color: '#FFFFFF',
  width: 20,
  height: 20,
};

export default Hidden;



// WEBPACK FOOTER //
// ./src/components/Icons/Hidden.jsx